import { useHttp } from 'hooks/http';
import { useToast } from 'hooks/toast';
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state';
import React from 'react';
import { FaEdit } from 'react-icons/fa';
import ModalFactory from 'react-modal-promise';
import { useHistory } from 'react-router';
import { ListIcon } from 'styles/icons';
import { distanceDateTime } from 'utils';
import { FaToggleOn, FaToggleOff } from 'react-icons/fa';
import {
  DotButton, ItemIcon,
  Menu, MenuItem,
} from '../../../components/CustomMenu';
import Flex, { Grid } from '../../../components/Flex';
import { Container, WrapperMenu } from './styles';

interface ISocialAction {
  id: string;
  user: string
  municipio: string;
  bairro: string;
  regiao: string;
  data_acao: string;
  partner_total: number;
  attendance_count: number,
  service_total: number;
  action_status: boolean,
  created_at: string;
  total_quantity: number;
  server_time: string;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();

  return `${day}/${month}/${year}`;
};

// eslint-disable-next-line arrow-body-style
const Card: React.FC<{ socialAction: ISocialAction }> = ({ socialAction }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const history = useHistory();
  const { httpPut } = useHttp();
  const { addToast } = useToast();

  const handleToggleStatus = async () => {
    const newStatus = !socialAction.action_status;

    try {
      await httpPut(`social-action/edit/${socialAction.id}`, {
        action_status: newStatus,
      });
      

      setTimeout(() => {
        window.location.reload();
      }, 1500); 
      
      addToast({
        title: 'Status da ação alterado com sucesso!',
        type: 'success',
      });

    } catch (error) {
      addToast({ title: 'Não foi possível gravar!', type: 'error' });
    }
  };

  return (
    <Container status={socialAction.action_status}>
      <WrapperMenu>
        <PopupState variant="popover" popupId="demo-popup-menu">
          {(popupState) => (
            <>
              <DotButton {...bindTrigger(popupState)} />
              <Menu {...bindMenu(popupState)}>
                <MenuItem
                  onClick={() => { history.push(`/social-action/detail/${socialAction.id}`); }}
                  style={{ width: 150 }}
                >
                  <ItemIcon icon={<FaEdit />} title="Detalhe" />
                </MenuItem>
                <MenuItem
                  onClick={() => { history.push(`/social-action/edit/${socialAction.id}`); }}
                  style={{ width: 150 }}
                >
                  <ItemIcon icon={<ListIcon />} title="Editar" />
                </MenuItem>
                <MenuItem
                  onClick={handleToggleStatus}
                  style={{ width: 150 }}
                >
                  <ItemIcon icon={socialAction.action_status ? <FaToggleOff /> : <FaToggleOn />} 
                  title={socialAction.action_status ? 'Desativar' : 'Ativar' }
                  />
                </MenuItem>
              </Menu>
            </>
          )}
        </PopupState>
      </WrapperMenu>
      <Grid container spacing={1}>
        <Flex title="Data da Ação" xs={12} sm={6} md={4}>
          {socialAction.data_acao ? formatDate(socialAction.data_acao) : 'Não identificado'}
        </Flex>

        <Flex title="Região" xs={12} sm={6} md={4}>
          {socialAction.regiao || 'Não identificado'}
        </Flex>

        <Flex title="Status" xs={12} sm={6} md={2}>
        {socialAction?.action_status === true ? 'Ativada' : socialAction?.action_status === false ? 'Desativada' : 'Nada Cadastrado'}
        </Flex>

        <Flex title="Criado Por" xs={12} sm={6} md={4}>
          {socialAction.user || 'Não cadastrado'}
        </Flex>

        <Flex title="Município" xs={12} sm={6} md={4}>
          {socialAction.municipio || 'Não identificado'}
        </Flex>
       
        <Flex title="Criado há" xs={12} sm={6} md={4}>
          {socialAction.created_at
            ? distanceDateTime(
              new Date(socialAction.created_at).toISOString(),
              new Date().toISOString(),
              false,
            )
            : 'Tempo não disponível'}
        </Flex>
        <Flex title="Bairro" xs={12} sm={6} md={4}>
          {socialAction.bairro || 'Fora da Capital'}
        </Flex>
        <Flex title="Público Presente" xs={12} sm={6} md={4}>
          {socialAction.attendance_count || 'Não cadastrado'}
        </Flex>
        <Flex title="Total de Serviços" xs={12} sm={6} md={4}>
          {socialAction.total_quantity || 'Não cadastrado'}
        </Flex>
      </Grid>
      <ModalFactory />
    </Container>
  );
};

export default Card;
